import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { navigateTo } from "utils/functions/navigationUtils";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../multiple-realms/login/styles/styled";
import LogoLogan from "./../assets/logo_logan.svg";

const UnauthorizedPage = () => {
  const router = useNavigate();
  const AUTHORIZATION_REQUIRED_DESCRIPTION = useTranslation({ id: "authorization_required_description" });
  const AUTHORIZATION_REQUIRED = useTranslation({ id: "authorization_required" });
  const PRIVACY_INFORMATION = useTranslation({ id: "privacy_information" });
  const SERVICE_NOW_ACCESS = useTranslation({ id: "service_now_access" });
  const IAM_ALREADY_REGISTERED = useTranslation({ id: "iam_already_registered" });
  const ambevServiceNowUrl = "https://abinbevww.service-now.com/abiex?id=sc_cat_item&sys_id=fc1e7ad0976ddd5027d47ad3f153afe0";

  const handleRedirectLogin = () => {
    router(`/multiple-realms`, undefined);
  };

  const handleRedirectServiceNow = () => {
    navigateTo(ambevServiceNowUrl);
  };

  return (
    <S.Container>
      <S.Content>
        <S.LogoContainer>
          <S.Logo src={LogoLogan} />
        </S.LogoContainer>
        <S.SSOContainer>
          <S.SSOContainerTitle>
            <div>
              <span className="login-title">{AUTHORIZATION_REQUIRED}</span>
            </div>
            <span className="login-subtitle">{AUTHORIZATION_REQUIRED_DESCRIPTION}</span>
          </S.SSOContainerTitle>
          <S.ContainerButtons>
            <S.SSOContainerButtonsContainer>
              <Button className="primaryButton" type="primary" onClick={handleRedirectServiceNow} size="large" data-testid="service_now_button">
                {SERVICE_NOW_ACCESS}
              </Button>
            </S.SSOContainerButtonsContainer>
            <S.SSOContainerButtonsContainer>
              <Button className="secondaryButton" size="large" onClick={handleRedirectLogin} data-testid="iam_already_registered_button">
                {IAM_ALREADY_REGISTERED}
              </Button>
            </S.SSOContainerButtonsContainer>
          </S.ContainerButtons>
        </S.SSOContainer>
      </S.Content>
      <S.FooterBar>
        <S.Label>{PRIVACY_INFORMATION}</S.Label>
      </S.FooterBar>
    </S.Container>
  );
};

export default UnauthorizedPage;
